export default __webpack_public_path__ + "static/media/paypal.58335d57.png";